import { configureStore } from "@reduxjs/toolkit";
import { reducer as formReducer } from "redux-form";

import { abTestReducer } from "Common/abTestUtils/redux";
import { siteConfigSlice } from "Common/Redux/siteConfig";

import { payrollLead } from "./api";

export const reducerSlices = {
  form: formReducer,
  abTests: abTestReducer,
  [siteConfigSlice.name]: siteConfigSlice.reducer,
  [payrollLead.reducerPath]: payrollLead.reducer,
};

export const createStore = (preloadedState) => {
  const store = configureStore({
    reducer: reducerSlices,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(payrollLead.middleware),
    preloadedState,
  });

  return store;
};
